import { useEffect, useState } from 'react';
import { Navbar } from '../../components/navbar';
import { Footer } from '../../components/footer';
import { scrollBodyToTop } from '../../utils/utils';
import AppConfig from '../../utils/appconfig';
import tireTracks from '../../images/tire-track.png';

const currentPage: string = '';

export function PotwierdzenieEmaila() {
    const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'already' | 'error'>('idle');
    const [email, setEmail] = useState('');
    const [manualToken, setManualToken] = useState('');

    const confirmToken = (token: string) => {
        setStatus('loading');

        fetch(`${AppConfig.apiPath}/confirm_email.php?token=${token}`)
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    setStatus('error');
                } else if (data.already_confirmed) {
                    setEmail(data.email);
                    setStatus('already');
                } else {
                    setEmail(data.email);
                    setStatus('success');
                }
            })
            .catch(() => setStatus('error'));
    };

    useEffect(() => {
        document.title = `Potwierdzenie email - ${AppConfig.baseTabTitle}`;
        scrollBodyToTop();

        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');

        if (token) {
            confirmToken(token);
        }
    }, []);

    const handleManualSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const trimmed = manualToken.trim();
        if (!trimmed) return;
        confirmToken(trimmed);
    };

    return (
        <div className="App theme-light">
            <Navbar currentPage={currentPage} />

            <div className="content-wrapper confirmation__content-wrapper">
                <div className="confirmation__box">
                    {status === 'idle' && (
                        <div className="confirmation__message">
                            <h2>Potwierdź adres email</h2>
                            <p>Wklej token z wiadomości email, aby potwierdzić swój adres.</p>
                            <form className="confirmation__manual-form" onSubmit={handleManualSubmit}>
                                <input
                                    className="confirmation__token-input"
                                    type="text"
                                    value={manualToken}
                                    onChange={(e) => setManualToken(e.target.value)}
                                    placeholder="Wklej token tutaj"
                                    autoFocus
                                />
                                <div className="custom-button__link-wrapper custom-button__link-wrapper--primary">
                                    <button type="submit" className="custom-button">
                                        Potwierdź
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}

                    {status === 'loading' && (
                        <div className="confirmation__message">
                            <h2>Weryfikacja adresu email...</h2>
                            <p>Proszę czekać.</p>
                        </div>
                    )}

                    {status === 'success' && (
                        <div className="confirmation__message confirmation__success">
                            <h2>✅ Adres email potwierdzony</h2>
                            <p>Adres <strong>{email}</strong> został pomyślnie potwierdzony.</p>
                            <p>Twoje zgłoszenie jest teraz kompletne.</p>
                        </div>
                    )}

                    {status === 'already' && (
                        <div className="confirmation__message confirmation__success">
                            <h2>✅ Adres email już potwierdzony</h2>
                            <p>Adres <strong>{email}</strong> był już wcześniej potwierdzony.</p>
                        </div>
                    )}

                    {status === 'error' && (
                        <div className="confirmation__message confirmation__error">
                            <h2>❌ Nieprawidłowy token</h2>
                            <p>Token jest nieprawidłowy lub wygasł.</p>
                            <form className="confirmation__manual-form" onSubmit={handleManualSubmit}>
                                <input
                                    className="confirmation__token-input"
                                    type="text"
                                    value={manualToken}
                                    onChange={(e) => setManualToken(e.target.value)}
                                    placeholder="Spróbuj ponownie — wklej token"
                                />
                                <div className="custom-button__link-wrapper">
                                    <button type="submit" className="custom-button">
                                        Spróbuj ponownie
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}
                </div>

                <img
                    src={tireTracks}
                    alt="Ślady opon"
                    className="confirmation__tire-track track-1"
                    loading="lazy"
                />
                <img
                    src={tireTracks}
                    alt="Ślady opon"
                    className="confirmation__tire-track track-2"
                    loading="lazy"
                />
            </div>

            <Footer currentPage={currentPage} />
        </div>
    );
}
